export const guides = [
  {
    id: "how-to-choose",
    title: "夫妻一起看电影，怎么挑才不会有人打瞌睡",
    excerpt:
      "口味不同、节奏不同、累了一天只想放空……选片其实有方法。这篇把「两个人的共识」拆成可执行的小步骤，让每次观影都变成期待。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20a%20couple%20choosing%20a%20movie%20on%20a%20warm%20lamp%20lit%20sofa%2C%20soft%20orange%20and%20cream%20tones%2C%20comfortable%20home%20atmosphere%2C%20editorial%20lifestyle%20photography%20style%2C%20high%20detail&width=800&height=600&seq=guide-choose-movie&orientation=landscape",
    date: "2026-09-28",
    author: "编辑部 · 小暖",
    readTime: "6 分钟",
    content: [
      "选片吵架，几乎是每对夫妻都经历过的日常。有人想看烧脑悬疑，有人只想窝着看甜甜的爱情片，最后往往以「随便吧」收场，谁也没尽兴。其实问题不在于品味不同，而在于没有找到属于你们两个人的选片规则。",
      "第一步，先定情绪，再定类型。回到家，先问一句「今天你想被治愈，还是想被刺激？」。方向定了，选择题就少了一大半。疲惫工作日的晚上，优先温情片；周末精力充沛，再考虑剧情更重的作品。",
      "第二步，用「轮流点菜」代替「少数服从多数」。这次你选，下次我选，被选中的人负责准备零食。把决定权变成一种轮流照顾对方的方式，争执自然就少了。",
      "第三步，给影片设置「随时可暂停」的默契。很多夫妻看到一半困了，硬撑反而留下坏印象。约好困了就明天继续，观影就变成一件轻松的事，而不是任务。",
      "第四步，看完留五分钟聊天。聊聊如果你是他会怎么选、哪个瞬间戳中了你。这一点点交流，才是共同观影真正的意义——你们不只是在看一部电影，而是在分享同一段时光。",
    ],
  },
  {
    id: "cozy-movie-night",
    title: "打造一个让人期待的家庭观影夜",
    excerpt:
      "关掉顶灯、铺好毯子、准备一杯热饮……仪式感不贵，却能让平凡的夜晚变得值得纪念。这里有一份零门槛的家庭观影夜布置清单。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20movie%20night%20setup%20with%20blanket%2C%20soft%20cushions%2C%20hot%20drinks%20and%20fairy%20lights%20in%20a%20living%20room%2C%20soft%20orange%20and%20cream%20tones%2C%20inviting%20home%20mood%2C%20editorial%20lifestyle%20photography%20style%2C%20high%20detail&width=800&height=600&seq=guide-movie-night&orientation=landscape",
    date: "2026-09-20",
    author: "编辑部 · 阿禾",
    readTime: "5 分钟",
    content: [
      "电影院有爆米花和巨幕，家里有什么？答案是：沙发、毯子，和一个不必在意形象的你。家庭观影夜的核心，是把单纯看片升级成一段被精心对待的时间。",
      "光线是第一位的。关掉刺眼的顶灯，只留一盏暖色落地灯或一串小夜灯。光线一柔，整个人的情绪就会跟着松下来。",
      "然后是触感。一条大毯子、两个抱枕，最好再有一双厚袜子。寒冷会让人分心，温暖会让人更容易投入剧情，也更容易靠在一起。",
      "饮品和零食要提前备好，别等片头了才起身。热可可、热牛奶、一壶花果茶都很合适；零食选小份、好拿、不吵的，才不会盖过台词。",
      "最后是手机规则。约定开场后手机静音放进茶几，谁先拿起来谁负责明早的早餐。小小的约定，会让两个人的注意力真正回到彼此身上。",
    ],
  },
  {
    id: "warm-movies-for-tired-days",
    title: "累到不想说话的日子，看这几类电影最治愈",
    excerpt:
      "有些晚上，我们不需要刺激，只想被轻轻抱住。温情片、生活流、美食与家庭题材，是疲惫夫妻的夜间良药。",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20evening%20window%20seat%20with%20a%20steaming%20cup%20and%20soft%20blanket%2C%20rain%20outside%2C%20warm%20orange%20and%20cream%20tones%2C%20calm%20healing%20atmosphere%2C%20editorial%20lifestyle%20photography%20style%2C%20high%20detail&width=800&height=600&seq=guide-healing-movies&orientation=landscape",
    date: "2026-09-11",
    author: "编辑部 · 小暖",
    readTime: "4 分钟",
    content: [
      "不是每个夜晚都有精力去理解复杂的叙事。累的时候，我们需要的不是反转，而是被温柔以待。好在有一类电影，专门为这种时刻而生。",
      "生活流温情片是首选。《海街日记》《小森林》这样的作品几乎没有激烈冲突，画面干净、节奏舒缓，看着看着，绷紧的肩膀就松下来了。",
      "美食题材同样有效。食物与家的联结天然带着安全感，《深夜食堂》《饮食男女》用一餐一饭抚平一天的疲惫，看完常常会想一起去厨房翻翻冰箱。",
      "家庭与陪伴主题也值得留一个位置。《飞屋环游记》《岁月神偷》会把有人陪着这件事变得格外具体，让人忍不住往身边挪近一点。",
      "小提示：疲惫的夜晚别选时长超过两小时的片子，也别选情绪太重的题材。治愈的前提，是看完之后你能安心睡个好觉。",
    ],
  },
  {
    id: "rewatch-classics",
    title: "值得和爱人反复重温的经典老片",
    excerpt:
      "经典之所以是经典，是因为每一次重看，都能看到新的东西，也看到不同阶段的你们自己。这份片单适合慢慢补、反复看。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20old%20cinema%20seats%20with%20warm%20projector%20light%2C%20soft%20orange%20and%20cream%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20detail&width=800&height=600&seq=guide-classic-rewatch&orientation=landscape",
    date: "2026-08-30",
    author: "编辑部 · 阿禾",
    readTime: "7 分钟",
    content: [
      "新片像惊喜，老片像老友。和同一个人反复看同一部电影，最奇妙的地方在于：电影没变，看的人却变了。",
      "《罗马假日》是永远的白月光。二十岁时你看的是赫本的美，三十岁再看，才懂那句有时候成全比拥有更深情。",
      "《当哈利遇上莎莉》值得每隔几年重看一次。年轻时觉得是喜剧，结婚后才明白，它讲的是两个人如何从朋友慢慢长成彼此最懂的人。",
      "《海上钢琴师》适合安静的夜晚。它提醒我们，人生真正的自由，是敢于选择自己想要的那条路。",
      "把这几部列进你们的年度重看清单吧。每年挑一个纪念日重温一部，多年之后，你们会拥有一份独属于自己的观影年表。",
    ],
  },
];